webpackJsonp([86164181414748],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/returns-policy.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"markdownRemark": {
				"html": "<div class=\"CalipsyContent\">\n    <div class=\"CalipsyContainer\">\n        <h1>Return policy</h1>\n        <p>Our policy lasts 15 days. If 15 days have gone by since your purchase, unfortunately we can’t offer you a refund.</p>\n        <p>You will be responsible for paying for your own shipping costs for returning the item. Shipping costs are non-refundable.</p>\n        <p>If you are shipping an item over £50, you should consider using a trackable shipping service or purchasing shipping insurance. We can’t guarantee that we will receive your returned item.</p>\n        <p>To be eligible for a return, the item must be unused, in the same condition that you've received it. Also, it must be in the original packaging.</p>\n        <p>We are not accepting returns on products made directly for customer’s request and the sale items.</p>\n        <p>Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your refund.<br>\n        If you are approved, then your refund will be processed, and a credit will automatically be applied to your credit card or original method of payment, within 10 working days from the date of receive the returned product.</p>\n        <p>Depending on where you live, the time it may take for your exchanged product to reach you, may vary.</p>\n    </div>  \n</div>  \n        \n        \n        ",
				"frontmatter": {
					"title": "Return Policy",
					"newsletter": false,
					"banner": {
						"imageUrl": "/images/about/aboutBanner.jpg",
						"type": "small",
						"anchor": "center"
					}
				}
			}
		},
		"pathContext": {
			"path": "/returns-policy"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---returns-policy-914239dc2b7f8111143b.js